/* 
Allows the connected wallet to increase their stake up to their LPT balance
*/
import { Stack, Text } from "@mantine/core";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState } from "react";
import { ethers } from "ethers";
import TextToNumberInput from "../components/TextToNumberInput";
import SmartContractAction from "../components/SmartContractAction";
import EthAddress from "../../EthAddress/EthAddress";

export default function IncreaseStake(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const bondingManager = useBondingManager();

  const bondLPT = async () => {
    try {
      if (!props.inputValue || props.inputValue == 0) {
        return;
      }
      const { ethereum } = window;
      if (ethereum) {
        const thisValue = ethers.utils.parseEther(props.inputValue.toString());
        setIsPending(true);
        let hints = null;
        if (ethers.BigNumber.from(thisValue).gt(ethers.BigNumber.from(props.allowance))) {
          setErrMsg(
            "LPT token allowance on Livepeer's BondingManager smart contract ran out"
          );
          props.setErr(true);
          return;
        }
        if (props.getHints) {
          hints = props.getHints(thisValue, "", props.orchestratorAddr);
        }
        console.log("Calculated hints:");
        console.log(hints);
        if (hints) {
          const txn = await bondingManager.bondWithHint(
            thisValue,
            props.orchestratorAddr,
            hints.oldDelegateNewPosPrev,
            hints.oldDelegateNewPosNext,
            hints.newDelegateNewPosPrev,
            hints.newDelegateNewPosNext
          );
          setTxn(txn.hash);
          await txn.wait();
        } else {
          const txn = await bondingManager.bond(thisValue, props.orchestratorAddr);
          setTxn(txn.hash);
          await txn.wait();
        }
        props.refreshWallet();
        setIsFinished(true);
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  return (
    <Stack spacing={24}>
      <EthAddress
        address={props.bondedWith}
        cachedENS={props.cachedENS}
        preamble={
          "You are currently staking " +
          (props.bondedLPT / ethers.constants.WeiPerEther).toFixed(2) +
          " LPT at "
        }
      />
      <TextToNumberInput
        inputValue={props.inputValue}
        setInput={props.setInput}
        min={0}
        max={props.balance / ethers.constants.WeiPerEther}
        placeholder={"LPT"}
        description={
          (props.balance / ethers.constants.WeiPerEther).toFixed(2) +
          " LPT is currently available in your wallet"
        }
        label={"Increase your LPT stake"}
      />
      <SmartContractAction
        isPending={isPending}
        txn={thisTxn}
        thisErrMsg={thisErrMsg}
        isFinished={isFinished}
        action={bondLPT}
        actionMessage={"Add " + props.inputValue + " LPT stake"}
        finishedMessage={"Successfully increased stake!"}
        pendingMessage={"Increasing Delegated Stake..."}
      />
      {thisErrMsg != "" ? (
        <Text size="xl" fw={700}>
          The previous transaction failed with reason `{thisErrMsg}`
        </Text>
      ) : null}
    </Stack>
  );
}
